var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.031A1.654 1.654 0 015.75 3.5H10V1.531a.708.708 0 00-.75-.656H6.731A2.066 2.066 0 005 0a2.066 2.066 0 00-1.731.875H.75a.708.708 0 00-.75.656v9.188a.708.708 0 00.75.656H4zm1-3.937a.708.708 0 01.75.656.708.708 0 01-.75.656.708.708 0 01-.75-.656.708.708 0 01.75-.656zm5.75 6.781H14v5.469a.708.708 0 01-.75.656h-7.5a.708.708 0 01-.75-.656V5.031a.708.708 0 01.75-.656H10v2.844a.71.71 0 00.75.656zM14 6.834V7h-3V4.375h.189a.808.808 0 01.53.192l2.061 1.8a.618.618 0 01.22.464z",
    fill: "#02b7b0"
  })));
}

export default SvgIconDocument;